module.exports = {
  '@brand-primary': '#117065',
  '@brand-success': '#42B7A6',

  /* --- Icon --- */
  '@color-icon-base': '@brand-primary',
  '@color-icon-faded': '#CCC',
};
